export default [
  { icon: 'mdi-account', title: 'Detil Profil', event: 'onDetil', akses: true },
  { icon: 'mdi-pencil', title: 'Edit Data', event: 'onEdit', akses: 'lpd-peserta-non-ptk.update' },
  { icon: 'mdi-delete', title: 'Hapus', event: 'onDelete', akses: 'lpd-peserta-non-ptk.delete' },
];
